import styles from "./styles.module.scss"
import CloseOutline from "~icons/eva/close-outline"
import CheckmarkOutline from "~icons/eva/checkmark-outline"
import classNames from "classnames"

export const StatusScreen = ({
  title,
  description,
  error,
}: {
  title: string
  description: string
  error: boolean
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={classNames(styles.iconContainer, error ? styles.error : styles.success)}>
          {error ? (
            <CloseOutline className={styles.icon} />
          ) : (
            <CheckmarkOutline className={styles.icon} />
          )}
        </div>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  )
}
